<template>
  <div
    class="header"
    :class="{'header--transparent': theme === 'transparent', 'header--white': theme === 'white', 'header--dark': theme === 'dark', 'header--footer': theme === 'footer'}"
  >
    <div class="container">
      <div class="row justify-content-between align-items-center">
        <div class="col-auto">
          <router-link :to="{name: 'home'}">
            <div class="image-container header-logo">
              <img src="@/assets/colored-logo.png" v-if="theme === 'white'">
              <img src="@/assets/logo.png" v-else>
            </div>
          </router-link>
        </div>
        <div class="col-auto header-phone-link d-none d-sm-flex">
          <a href="tel:+77779257787" class="header-phone-link-first">+7 (777) 925 77 87</a>
          <!--<a href="tel:+77056232000" class="d-none d-md-inline">+7 (705) 623 20 00</a>-->
          <a :href="pricelist" target="_blank" class="header-phone-link--btn">
            <ButtonSlider msg="Прайс-лист" theme="header-btn"/>
          </a>
        </div>
        <ul class="col-auto d-none d-xl-block header-nav">
          <li class="header-nav__item">
            <router-link :to="{name: 'home'}">О Компании</router-link>
          </li>
          <li class="header-nav__item">
            <router-link :to="{name: 'category', params: {id: 'stone'}}">Щебень</router-link>
          </li>
          <li class="header-nav__item">
            <router-link :to="{name: 'category', params: {id: 'sand'}}">Отсев</router-link>
          </li>
          <li class="header-nav__item">
            <router-link :to="{name: 'certificates'}">Сертификаты</router-link>
          </li>
          <li class="header-nav__item">
            <router-link :to="{name: 'contacts'}">Контакты</router-link>
          </li>
        </ul>
        <div class="col-auto d-block d-xl-none" v-if="theme !== 'footer'">
          <div class="header__mobile-nav-hamburg" @click="toggleMobNav"></div>
        </div>
        <MobileNav
          v-if="theme !== 'footer'"
          :isOpen="isMobNavOpen"
          @onCloseMobileNav="toggleMobNav"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MobileNav from "@/components/MobileNav.vue";
import ButtonSlider from "@/components/ButtonSlider.vue";

import { mapGetters } from "vuex";

export default {
  name: "Header",
  props: {
    theme: {
      type: String,
      required: false,
      default: "dark"
    }
  },
  components: {
    MobileNav,
    ButtonSlider
  },
  data() {
    return {
      isMobNavOpen: false
    };
  },
  computed: {
    ...mapGetters("pricelist", ["pricelist"])
  },
  methods: {
    toggleMobNav() {
      this.isMobNavOpen = !this.isMobNavOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.header {
  background-color: $black-color;
  color: $white-color;
  border-bottom: 1px solid $gray-color;
  font-size: 1.6rem;
  opacity: 1;
  transition: all 0.3s;
}
.header--transparent {
  background-color: transparent;
  border-bottom: 1px solid $dark-white-color;
}
.header--white {
  background-color: $white-color;
  color: $black-color;
}
.header-logo {
  width: 163px;
  height: 57px;
}
.header-logo img {
  margin-left: 0;
}
.header-phone-link a {
  color: $white-color;
  text-decoration: none;
}
.header-phone-link-first {
  margin-right: 20px;
}
.header-phone-link--btn {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 1450px) {
  .header-phone-link-first {
    display: none;
  }
}
.header-nav {
  text-align: right;
}
.header-nav__item {
  display: inline-block;
  list-style-type: none;
  text-align: left;
  font-size: 17px;
}
.header-nav__item a {
  position: relative;
  display: inline-block;
  padding: 30px 20px;
  color: $white-color;
  text-decoration: none;
  &.router-link-exact-active {
    color: $white-color;
    background-color: rgba(255, 255, 255, 0.2);
  }
}
@media only screen and (max-width: 576px) {
  .header {
    font-size: 1.2rem;
  }
  .header-nav__item a {
    padding: 30px 6px;
  }
}
.header-nav__item a.router-link-exact-active::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  background-color: $white-color;
}
.header--white .header-nav__item a {
  color: $black-color;
  &.router-link-exact-active {
    color: $black-color;
    background-color: $dark-white-color;
  }
}
.header--white .header-nav__item a.router-link-exact-active::after {
  background-color: $black-color;
}
.header--white .header-phone-link a {
  color: $black-color;
}

.header--footer .header-nav__item a.router-link-exact-active::after {
  top: 0;
  left: 0;
  bottom: auto;
  right: auto;
}
.header--footer {
  border: none;
  border-top: 1px solid $gray-color;
}
.header__mobile-nav-hamburg {
  width: 33px;
  height: 21px;
  margin-top: 20px;
  margin-bottom: 20px;
  background: url(../assets/hamburg-menu-mobile.svg) no-repeat center center;
}

.header-phone-link {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
